//
// Copyright 2024 DXOS.org
//

export const LOCK_KEY = 'dxos-client-worker';
